
var TaxIdService = function($http, $q, configManager, userProfileManager, cookieUtil, AccountConfigManager) {
    var triggerTaxIdEmail = function() {
        var email = userProfileManager.getUserProfileMasterInfo().emailId;
        var eid = cookieUtil.getCookie('USER_PROFILE_JWT').replace(/\"/g, '');
        var gigyaId = userProfileManager.getUserProfileMasterInfo().gigyaId;

        var accountConfigManager = AccountConfigManager.getConfig(configManager);
        var locale = accountConfigManager['languageCode'] + '_' + accountConfigManager.site['countryCode'];
        var sapEndpoint = accountConfigManager.site['legacyServer'];
        var taxIdEmailUrl = sapEndpoint + '/esb-util/api/v1/message?eid={eid}&locale={locale}';

        var payload = {
            'messageID': 'SIRET-instructions',
            'sendToEmail': email,
            'messageData': {
                'gigyaId': gigyaId
            }
        };

        var aUrl = taxIdEmailUrl.replace('{eid}', eid).replace('{locale}', locale);

        var promise = $http.post(aUrl, payload);
        promise.then(function(data) {
            if (data.status == 200) {

            } else {

            }
        }, function(data) {

        });
    };

    return {
        'triggerTaxIdEmail': triggerTaxIdEmail
    };
};

export default TaxIdService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/tax-id-service.js
// module id = 24
// module chunks = 0